var map = {
	"./de.json": "e45a",
	"./en.json": "07a7",
	"./es.json": "a16d",
	"./fr.json": "834a",
	"./it.json": "20cd",
	"./nl.json": "8af2",
	"./sv.json": "0091"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3273";